import { topicItems } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10 flex-wrap">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">当前全网最火的网红爆料话题讨论</p>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-foreground-400 ml-auto">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></div>
            实时热度
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, index) => {
            const isHot = item.heat >= 80;
            return (
              <div
                key={item.id}
                className={`group flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all ${
                  isHot
                    ? 'bg-primary-50 border-primary-200 hover:border-primary-300'
                    : 'bg-background-50 border-background-200 hover:border-background-300'
                }`}
              >
                <span
                  className={`text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full shrink-0 ${
                    index < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.count}</div>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                  <span className="text-xs font-semibold text-primary-600">{item.heat}°</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}